import styled from "styled-components";

export const ContainerNotification = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

export const ContainerQtdNotification = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  background-color: #eb5861;
  margin-bottom: -14px;
  margin-left: 16px;
  padding: 2px;

  color: #fff;
  font-size: 10px;
  font-family: "Inter";
`;
